export class PersonData {
  name = '';
  age = 0;
  health = '';
}
